import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import React from "react";
import AssessmentDetailCard from "./AssessmentDetailCard";
import { AssessmentDetail } from "./types";

interface AssessmentDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  assessment: AssessmentDetail;
}

const AssessmentDetailModal: React.FC<AssessmentDetailModalProps> = ({ isOpen, onClose, assessment }) => {
  if (!assessment) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="hidden" />
        <ModalBody className="p-0">
          <AssessmentDetailCard assessment={assessment} variant="embedded" />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" variant="light" onPress={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AssessmentDetailModal;

